var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconWithdraw = function SvgIconWithdraw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-withdraw_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 13.312a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 3.936H3.75a.625.625 0 0 0-.625.625v13.213a2.413 2.413 0 0 0 2.412 2.412h8.925a2.413 2.413 0 0 0 2.413-2.412V4.561a.625.625 0 0 0-.625-.625ZM10 14.562a3.75 3.75 0 1 1 0-7.501 3.75 3.75 0 0 1 0 7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1.436h-15A1.875 1.875 0 0 0 .625 3.311v3.75a1.875 1.875 0 0 0 1.25 1.763V4.561A1.875 1.875 0 0 1 3.75 2.686h12.5a1.875 1.875 0 0 1 1.875 1.875v4.263a1.875 1.875 0 0 0 1.25-1.763v-3.75A1.875 1.875 0 0 0 17.5 1.436Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-withdraw_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .811)",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconWithdraw;